import { useState } from "react";
import { QITracksListCard, QISpinner, QIErrorBoundary } from "../../../components";
import { header } from "./tableHeader";
import { TableWrapper } from "./TableWrapper";
import { NoData } from "../../Shared";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const TripsList = ({
  data,
  resetCount,
  selectedRange,
  setSelectedRange,
  error,
  listData,
  setHighlight,
  highlight,
  setTripTime,
  listType,
  setResetCount,
  tripSearch,
  setTripSearch,
  setShowEventsDetails,
  showEventsDetails,
  setDockAlign,
  setMapExpand,
  isFetching,
  isSuccess,
  batchSize,
  onBatchSizeChange = () => {},
  hasMore,
  isLoadingMore,
  onLoadMore = () => {},
  setActivitiesTimeRange = () => {},
  selectedId,
}) => {
  const navigate = useNavigate();
  const [view, setView] = useState("Table");

  const getEndTime = (endTime) => {
    if (endTime !== null) {
      return moment(endTime);
    } else {
      return moment();
    }
  };

  //Handle Row Selection
  const handleRowClick = (data) => {
    setActivitiesTimeRange({
      start_time: moment(data?.start_time),
      end_time: getEndTime(data?.end_time),
    });
  };

  const message = {
    header: error?.data?.message,
  };

  return (
    <>
      {error && <QIErrorBoundary message={message} />}
      {isFetching && (
        <div className="no-data">
          <QISpinner size="50px" />
        </div>
      )}
      {!isFetching && data?.trips?.length ? (
        <TableWrapper
          data={data?.trips || []}
          header={header}
          error={error}
          isSuccess={true}
          batchSize={batchSize}
          onBatchSizeChange={onBatchSizeChange}
          hasMore={hasMore}
          isLoadingMore={isLoadingMore}
          onLoadMore={onLoadMore}
          tableHandlers={{
            rowHandler: handleRowClick,
          }}
          highlight={highlight}
          setHighlight={setHighlight}
          listType={listType}
          selectedId={selectedId}
        />
      ) : (
        isSuccess && !error && !isFetching && <NoData />
      )}
    </>
  );
};

export default TripsList;
